import { SET_HIGHLIGHTED_FEATURES, HIGHLIGHT_FEATURES, UNHIGHLIGHT_FEATURES } from './Types';
import _ from 'lodash';
import { HighlightedFeature, IHighlightsAction, IHighlightsReducerState } from './highlightsTypes';

const defaultState = {
    highlightFilters: {},
    viewerHighlights: [],
    highlightedFeatures: [],
    features: new Map(),
    panelVisible: false,
    panelInFront: false
};

/* highlightedFeatures object format
{
    key: string,
    layerSystemName: string,
    features: [
        featureId: string/number,
        properties: object,
        lngLat: object
    ]
}
 */

export default function reducer(
    state: IHighlightsReducerState = defaultState,
    action: IHighlightsAction
) {
    switch (action.type) {
        case SET_HIGHLIGHTED_FEATURES:
            return setHighlightedFeatures(state, action.highlights);
        case HIGHLIGHT_FEATURES:
            return highlightFeatures(state, action.highlights);
        case UNHIGHLIGHT_FEATURES:
            return unhighlightFeatures(state, action.highlights);
        default:
            return state;
    }
}

function setHighlightedFeatures(state: IHighlightsReducerState, highlights: HighlightedFeature[]) {
    return {
        ...state,
        highlightedFeatures: _.uniqWith(highlights, highlightComparator)
    };
}

function highlightFeatures(state: IHighlightsReducerState, highlights: HighlightedFeature[]) {
    const diff = _.differenceWith(state.highlightedFeatures, highlights, highlightComparator);
    return {
        ...state,
        highlightedFeatures: _.unionWith(diff, highlights, highlightComparator)
    };
}

function unhighlightFeatures(state: IHighlightsReducerState, highlights: HighlightedFeature[]) {
    return {
        ...state,
        highlightedFeatures: _.differenceWith(
            state.highlightedFeatures,
            highlights,
            highlightComparator
        )
    };
}

function highlightComparator(
    object: {
        layerSystemName: any;
        key: any;
    },
    other: {
        layerSystemName: any;
        key: any;
    }
) {
    return object.layerSystemName === other.layerSystemName && object.key === other.key;
    // && object.featureId === other.featureId
}
